<template>
  <div class="main-container">
<!--    <div class="img-container container-item">-->
<!--      <img src="./image/404.svg">-->
<!--    </div>-->
    <div class="text-container container-item">
      <div class="code">404</div>
      <div class="msg">你查看的页面貌似丢失了呢...</div>
      <a class="action" href="#" @click="goBack"><div>返回首页,查看更多内容.</div></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'errorPage',
    methods:{
      goBack(){
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped>
  .main-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #eee;
  }
  .main-container .text-container .code {
    font-size: clamp(150px,20vw,200px);
    font-family: 'Arial Narrow';
    color: rgb(86, 86, 253);
    font-weight: bolder;
    text-align: center;
  }
  .main-container .text-container .msg {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .main-container .text-container .action {
    color: #0f0f0f;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    text-decoration-line: none;
  }
  .main-container .text-container a:hover{
    color: #5bc0de;
  }

</style>
